import { CollaborationResult } from '@/infrastructure/gateways/classroom/models/collaboration-result';
import { Classroom } from '@/presentation/screens/classroom/classroom.vm';

const collaborationName = 'GetClassroomByTopic';

export const ObtainedClassroomIdentifier = 'ObtainedClassroom';
export class ObtainedClassroom extends CollaborationResult<Classroom> {
  constructor(data: Classroom) {
    super(collaborationName, ObtainedClassroomIdentifier, 'Classroom successfully obtained', data);
  }
}

export const UnavailableServiceIdentifier = 'UnavailableService';
export class UnavailableService extends CollaborationResult<Classroom> {
  constructor() {
    super(collaborationName, UnavailableServiceIdentifier, 'Unavailable service');
  }
}

export const LessonOrDisciplineNotFoundIdentifier = 'LessonOrDisciplineNotFound';
export class LessonOrDisciplineNotFound extends CollaborationResult<Classroom> {
  constructor() {
    super(
      collaborationName,
      LessonOrDisciplineNotFoundIdentifier,
      'Failed to load classroom cecause lesson or discipline not found',
    );
  }
}

export const TopicSlugNotSentIdentifier = 'TopicSlugNotSent';
export class TopicSlugNotSent extends CollaborationResult<Classroom> {
  constructor() {
    super(collaborationName, TopicSlugNotSentIdentifier, 'Topic slug not sent but is required');
  }
}

export const UnauthorizedStudentBecauseNotIdentifiedIdentifier =
  'UnauthorizedStudentBecauseNotIdentified';
export class UnauthorizedStudentBecauseNotIdentified extends CollaborationResult<Classroom> {
  constructor() {
    super(
      collaborationName,
      UnauthorizedStudentBecauseNotIdentifiedIdentifier,
      'Unauthorized beacause user is not identified',
    );
  }
}
